import { CheckCircle } from '@mui/icons-material';
import { Grid, Paper, styled } from '@mui/material';
import React from 'react';
import { WsButton, WsChip, WsChipVariants, WsColors } from 'wisestep-base';

import AIInfoSection from './AIInfoSection';

const Container = styled(Paper)<{ bgcolor?: string }>(({ theme, bgcolor }) => ({
  borderRadius: 8,
  backgroundColor: bgcolor || 'transparent',
  padding: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
}));

interface IAIEnhanceBarProps {
  progress: number;
  title?: string;
  subtitle?: string;
  showButton?: boolean;
  disabled?: boolean;
  onEnhanceClick?: () => void;
  withBackground?: boolean;
  enhanceButtonText?: string;
}

const AIEnhanceBar: React.FC<IAIEnhanceBarProps> = ({
  progress,
  title,
  subtitle,
  showButton = true,
  disabled = false,
  onEnhanceClick,
  withBackground = false,
  enhanceButtonText = 'AI Enhance',
}) => {
  const renderAction = () => {
    if (disabled && showButton) {
      return (
        <WsChip
          icon={<CheckCircle color="success" />}
          value="Updated Successfully"
          variant={WsChipVariants.SUCCESS}
          borderColor={WsColors.Green500}
        />
      );
    }

    return (
      onEnhanceClick &&
      showButton && (
        <WsButton variant="contained" onClick={onEnhanceClick} disabled={disabled || progress > 90}>
          {enhanceButtonText}
        </WsButton>
      )
    );
  };

  return (
    <Container
      elevation={0}
      bgcolor={withBackground ? WsColors.background_grey_shadow : WsColors.background_white_shadow}
    >
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs>
          <AIInfoSection progress={progress} title={title} subtitle={subtitle} />
        </Grid>
        <Grid item>{renderAction()}</Grid>
      </Grid>
    </Container>
  );
};

export default AIEnhanceBar;
